import axios from "axios";
import Cookies from "js-cookie";

const Axios = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    timeout: 100000,
});

// Utility to get and store the token
const getToken = async (): Promise<string | null> => {
    // const tokenKey =
    //   process.env.NEXT_PUBLIC_KINDE_ACCESS_TOKEN || 'kinde_access_token';

    const token = Cookies.get(import.meta.env.VITE_KINDE_ACCESS_TOKEN || "kinde_access_token");
    // let token = localStorage.getItem(tokenKey);

    return token || null;
};

// Add Axios request interceptor
Axios.interceptors.request.use(
    async (config) => {
        try {
            const token = await getToken();
            if (token) {
                // Ensure headers are properly set
                config.headers = config.headers || {};
                config.headers.set("Authorization", `Bearer ${token}`);
            }
        } catch (error) {
            console.error("Error setting authorization header:", error);
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle 401 errors
Axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Clear all cookies
            Object.keys(Cookies.get()).forEach((cookie) => Cookies.remove(cookie));

            // Clear local storage
            localStorage.clear();

            // Optionally redirect to login page
            // window.location.href = "/login"; // Uncomment if needed
        }
        return Promise.reject(error);
    }
);

export default Axios;
